export enum AuthFormAction {
  signIn = 'signIn',
  signUp = 'signUp',
}

export enum LoginInputType {
  phone = 'phone',
  email = 'email',
}
